import { forwardRef } from 'react';
import { CheckboxProps } from '@mui/material/Checkbox';
import MuiCheckbox from '@mui/material/Checkbox';
import CheckBoxIcon from 'components/icons/CheckboxIcon';
import CheckeboxIconChecked from 'components/icons/CheckboxIconChecked';

interface ICheckBox extends CheckboxProps {
  label?: string;
  labelHtml?: JSX.Element;
  labelAction?: () => void;
  errorMsg?: string | undefined;
}

const CheckBox = forwardRef<HTMLButtonElement, ICheckBox>(
  function CheckBoxWithForwardRef(
    { label, labelHtml, labelAction = () => {}, errorMsg, ...props },
    ref
  ) {
    return (
      <>
        <div className="checkbox-container">
          <MuiCheckbox
            {...props}
            ref={ref}
            icon={<CheckBoxIcon />}
            checkedIcon={<CheckeboxIconChecked />}
            sx={{
              padding: 0,
              '& rect': { stroke: errorMsg ? '#d32f2f' : '#B2B2B2' },
            }}
          />
          {label && (
            <label className="checkbox-container__label">{label}</label>
          )}
          {labelHtml && (
            <button
              className={`checkbox-container__label ${errorMsg ? 'error' : ''}`}
              onClick={labelAction}
            >
              {labelHtml}
            </button>
          )}
        </div>
        {errorMsg && (
          <div className="checkbox-container__helper-text">{errorMsg}</div>
        )}
      </>
    );
  }
);

export default CheckBox;
